var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 104,
    viewBox: "0 0 248 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.214 77.8978C118.595 77.8978 120.332 78.4109 121.425 79.4371C122.519 80.455 123.066 81.8597 123.066 83.6515C123.066 84.459 122.944 85.2329 122.7 85.9731C122.456 86.705 122.056 87.3569 121.501 87.9289C120.954 88.5009 120.222 88.9552 119.306 89.2916C118.389 89.6197 117.257 89.7837 115.911 89.7837H114.233V96.345H110.322V77.8978H116.214ZM116.012 81.1027H114.233V86.5788H115.52C116.252 86.5788 116.887 86.4821 117.425 86.2886C117.964 86.0951 118.38 85.7923 118.675 85.3801C118.969 84.9679 119.116 84.438 119.116 83.7903C119.116 82.8818 118.864 82.2088 118.359 81.7714C117.854 81.3256 117.072 81.1027 116.012 81.1027ZM126.548 96.345V77.8978H130.46V93.1148H137.942V96.345H126.548ZM152.452 96.345L151.115 91.954H144.39L143.052 96.345H138.838L145.349 77.8221H150.131L156.667 96.345H152.452ZM150.181 88.6734L148.844 84.3833C148.76 84.0973 148.646 83.7314 148.503 83.2856C148.369 82.8313 148.23 82.3729 148.087 81.9102C147.952 81.4392 147.843 81.0312 147.759 80.6863C147.675 81.0312 147.557 81.4602 147.405 81.9733C147.262 82.478 147.124 82.9575 146.989 83.4117C146.854 83.866 146.758 84.1898 146.699 84.3833L145.374 88.6734H150.181ZM166.118 96.345H162.206V81.1531H157.197V77.8978H171.127V81.1531H166.118V96.345ZM177.814 96.345H173.966V77.8978H184.54V81.1027H177.814V85.8596H184.073V89.0519H177.814V96.345ZM204.892 87.0961C204.892 88.5177 204.715 89.8132 204.362 90.9824C204.009 92.1432 203.47 93.1443 202.747 93.9854C202.032 94.8266 201.124 95.4743 200.022 95.9286C198.92 96.3744 197.616 96.5973 196.11 96.5973C194.604 96.5973 193.3 96.3744 192.199 95.9286C191.097 95.4743 190.184 94.8266 189.46 93.9854C188.745 93.1443 188.211 92.139 187.858 90.9698C187.505 89.8005 187.328 88.5009 187.328 87.0709C187.328 85.1614 187.639 83.5001 188.262 82.0869C188.893 80.6653 189.86 79.5633 191.164 78.781C192.468 77.9987 194.125 77.6075 196.135 77.6075C198.137 77.6075 199.782 77.9987 201.069 78.781C202.364 79.5633 203.323 80.6653 203.946 82.0869C204.577 83.5085 204.892 85.1782 204.892 87.0961ZM191.429 87.0961C191.429 88.3831 191.589 89.4935 191.908 90.4272C192.236 91.3525 192.745 92.0675 193.435 92.5723C194.125 93.0686 195.016 93.3167 196.11 93.3167C197.22 93.3167 198.12 93.0686 198.81 92.5723C199.5 92.0675 200.001 91.3525 200.312 90.4272C200.631 89.4935 200.791 88.3831 200.791 87.0961C200.791 85.1614 200.43 83.6389 199.706 82.5285C198.983 81.4181 197.792 80.8629 196.135 80.8629C195.033 80.8629 194.133 81.1153 193.435 81.62C192.745 82.1163 192.236 82.8313 191.908 83.765C191.589 84.6903 191.429 85.8007 191.429 87.0961ZM214.09 77.8978C215.764 77.8978 217.144 78.0996 218.229 78.5034C219.323 78.9072 220.134 79.517 220.664 80.333C221.194 81.1489 221.459 82.1794 221.459 83.4244C221.459 84.2655 221.299 85.0016 220.98 85.6325C220.66 86.2634 220.239 86.7975 219.718 87.2349C219.196 87.6723 218.633 88.0298 218.027 88.3074L223.453 96.345H219.112L214.709 89.2664H212.627V96.345H208.715V77.8978H214.09ZM213.813 81.1027H212.627V86.0867H213.889C215.184 86.0867 216.109 85.8722 216.664 85.4432C217.228 85.0058 217.51 84.3665 217.51 83.5253C217.51 82.6505 217.207 82.028 216.601 81.6579C216.004 81.2877 215.075 81.1027 213.813 81.1027ZM233.585 96.345L229.143 81.8724H229.03C229.047 82.2172 229.072 82.7388 229.106 83.437C229.148 84.1267 229.185 84.8628 229.219 85.6451C229.253 86.4274 229.27 87.134 229.27 87.7649V96.345H225.774V77.8978H231.099L235.465 92.0045H235.541L240.171 77.8978H245.496V96.345H241.85V87.6135C241.85 87.033 241.858 86.3643 241.875 85.6072C241.9 84.8502 241.929 84.1309 241.963 83.4496C241.997 82.7598 242.022 82.2425 242.039 81.8976H241.925L237.168 96.345H233.585Z",
    fill: "#184037"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136.871 62L134.035 52.6884H119.773L116.937 62H108L121.807 22.7201H131.948L145.808 62H136.871ZM132.055 45.7315L129.219 36.634C129.04 36.0275 128.799 35.2515 128.496 34.3061C128.211 33.3428 127.916 32.3706 127.613 31.3895C127.328 30.3906 127.096 29.5254 126.917 28.7941C126.739 29.5254 126.489 30.4352 126.168 31.5233C125.865 32.5936 125.571 33.6104 125.285 34.5737C125 35.5369 124.795 36.2237 124.67 36.634L121.86 45.7315H132.055ZM163.254 22.8807C168.302 22.8807 171.986 23.9688 174.305 26.1451C176.624 28.3035 177.783 31.2825 177.783 35.0821C177.783 36.7945 177.525 38.4357 177.007 40.0054C176.49 41.5574 175.643 42.9398 174.465 44.1528C173.306 45.3658 171.754 46.3291 169.81 47.0426C167.865 47.7383 165.466 48.0862 162.612 48.0862H159.053V62H150.758V22.8807H163.254ZM162.826 29.6771H159.053V41.2898H161.782C163.334 41.2898 164.681 41.0846 165.823 40.6744C166.964 40.2641 167.847 39.6219 168.472 38.7478C169.096 37.8737 169.408 36.7499 169.408 35.3764C169.408 33.4499 168.873 32.0228 167.803 31.0952C166.732 30.1498 165.074 29.6771 162.826 29.6771ZM207.698 62H185.168V22.8807H207.698V29.6771H193.463V38.2662H206.708V45.0626H193.463V55.1501H207.698V62ZM247.513 62H238.041L228.943 47.2032L219.846 62H210.962L223.94 41.8249L211.792 22.8807H220.943L229.372 36.9551L237.64 22.8807H246.577L234.295 42.2798L247.513 62Z",
    fill: "url(#paint0_linear_312_405)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_312_405)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6601 42.1899H36.1001C35.0062 42.1904 33.9317 42.4788 32.9847 43.0262C32.0377 43.5737 31.2515 44.3608 30.7052 45.3085C30.1589 46.2562 29.8717 47.331 29.8726 48.4249C29.8734 49.5188 30.1623 50.5931 30.7101 51.5399L50.4901 85.8099C52.7146 89.6628 55.9142 92.8622 59.7673 95.0863C63.6204 97.3103 67.9912 98.4808 72.4401 98.4799H82.2101L49.6601 42.1899Z",
    fill: "url(#paint1_linear_312_405)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.71 51.5399L50.49 85.8099C52.378 89.0816 54.9747 91.889 58.0895 94.0261C61.2043 96.1632 64.758 97.5757 68.49 98.1599L36.18 42.1599H36.09C34.9926 42.159 33.9143 42.4481 32.9645 42.9978C32.0146 43.5474 31.2268 44.3383 30.6808 45.2903C30.1348 46.2423 29.8499 47.3216 29.855 48.419C29.8602 49.5165 30.1551 50.5931 30.71 51.5399Z",
    fill: "url(#paint2_linear_312_405)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.71 51.5399C30.1668 50.6178 29.8746 49.5694 29.8623 48.4993C29.85 47.4291 30.1181 46.3743 30.64 45.4399L0 98.4399H12.63C17.087 98.4476 21.4673 97.2804 25.3296 95.0561C29.1919 92.8318 32.3997 89.6288 34.63 85.7699L42.53 72.0099L30.71 51.5399Z",
    fill: "url(#paint3_linear_312_405)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.71 51.5399C30.1668 50.6178 29.8746 49.5694 29.8623 48.4993C29.85 47.4291 30.1181 46.3743 30.64 45.4399L0 98.4399H12.63C17.087 98.4476 21.4673 97.2804 25.3296 95.0561C29.1919 92.8318 32.3997 89.6288 34.63 85.7699L42.53 72.0099L30.71 51.5399Z",
    fill: "url(#paint4_linear_312_405)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.58 85.8101L42.53 72.0101L35.65 60.0801L13.5 98.4401C17.7961 98.294 21.9846 97.0582 25.672 94.8489C29.3594 92.6396 32.4247 89.5293 34.58 85.8101Z",
    fill: "url(#paint5_linear_312_405)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0801 0.0100098L41.2101 8.43001C38.989 12.2832 37.8198 16.6525 37.8198 21.1C37.8198 25.5475 38.989 29.9169 41.2101 33.77L74.0401 90.62C76.3801 94.85 77.0401 98.48 72.4401 98.48H88.6701C90.1157 98.481 91.5361 98.1011 92.7883 97.3787C94.0405 96.6563 95.0803 95.6169 95.8031 94.3649C96.5259 93.1129 96.9061 91.6927 96.9056 90.2471C96.9051 88.8014 96.5238 87.3814 95.8001 86.13L46.0801 0.0100098Z",
    fill: "url(#paint6_linear_312_405)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0801 0.0100098L41.2101 8.43001C38.989 12.2832 37.8198 16.6525 37.8198 21.1C37.8198 25.5475 38.989 29.9169 41.2101 33.77L74.0401 90.62C76.3801 94.85 77.0401 98.48 72.4401 98.48H88.6701C90.1157 98.481 91.5361 98.1011 92.7883 97.3787C94.0405 96.6563 95.0803 95.6169 95.8031 94.3649C96.5259 93.1129 96.9061 91.6927 96.9056 90.2471C96.9051 88.8014 96.5238 87.3814 95.8001 86.13L46.0801 0.0100098Z",
    fill: "url(#paint7_linear_312_405)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M40.3598 10.0601C38.556 13.7815 37.6904 17.8878 37.8385 22.0207C37.9867 26.1536 39.1441 30.1874 41.2098 33.7701L74.0398 90.6201C76.3798 94.8501 77.0398 98.4801 72.4398 98.4801H86.3098C87.1222 97.2163 87.569 95.7524 87.6008 94.2505C87.6325 92.7485 87.248 91.267 86.4898 89.9701L40.3598 10.0601Z",
    fill: "url(#paint8_linear_312_405)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_312_405",
    x1: 243.5,
    y1: 66.5,
    x2: 50.5,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0517504,
    stopColor: "#456E51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBEB98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_312_405",
    x1: 62.8101,
    y1: 86.7999,
    x2: 51,
    y2: 131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#143F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#497253"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_312_405",
    x1: 63.01,
    y1: 99.6299,
    x2: 35.66,
    y2: 49.0799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#143F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#265240"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_312_405",
    x1: 33.08,
    y1: 63.3999,
    x2: 5.85001,
    y2: 113.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C0078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2FEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_312_405",
    x1: 31.3518,
    y1: 62.6,
    x2: -29.8666,
    y2: 21.8008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#143F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#376049"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_312_405",
    x1: 34.9,
    y1: 72.5001,
    x2: 20.5,
    y2: 102.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#143F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#376049"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_312_405",
    x1: 32.5201,
    y1: 4.33001,
    x2: 88.1501,
    y2: 97.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF73EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_312_405",
    x1: 32.5201,
    y1: 4.33001,
    x2: 88.1501,
    y2: 97.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#497353"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_312_405",
    x1: 21.9698,
    y1: -3.55994,
    x2: 73.4198,
    y2: 82.8701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#265240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A4542"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_312_405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96.92,
    height: 98.48,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5fbdbb123d18cb10948c610be7e04871.svg";
export { ForwardRef as ReactComponent };